module.exports = __webpack_public_path__ + "static/media/achievement2.515039c9.png";